import { motion } from "framer-motion";

export default function PageTransition({ children, pathKey }) {
  return (
    <motion.div
      key={pathKey}
      initial={{ opacity: 0, y: 24, scale: 0.985 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -24, scale: 0.985 }}
      transition={{
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1], // 🔥 premium easing
      }}
      className="h-full will-change-transform"
    >
      {children}
    </motion.div>
  );
}